import { leadsOpportunitiesListOptions } from '@crm/api'
import { OpportunitiesTable, OpportunityHeader } from '@crm/components'
import { useQueryParams } from '@shared/hooks'
import { useQuery } from '@tanstack/react-query'
import { Flex } from 'antd'
import { useParams } from 'react-router-dom'

import { OpportunitiesFilter } from './OpportunitiesFilter'

export const OpportunitiesCol = () => {
  const { id } = useParams()
  const params = useQueryParams()

  const { data, isLoading } = useQuery({
    ...leadsOpportunitiesListOptions({
      path: { lead_id: id! },
      query: { ...params }
    }),
    enabled: !!id
  })

  return (
    <Flex vertical gap={16}>
      <OpportunitiesTable
        data={data}
        isLoading={isLoading}
        {...(id && { leadId: Number(id) })}
        leftChildren={<OpportunitiesFilter />}
        rightChildren={<OpportunityHeader hideSegmented isLeadOpportunityTab />}
      />
    </Flex>
  )
}
